'use client';

import { useQuery } from '@tanstack/react-query';
import type { BurnStatsData } from '@/app/api/rpc/burn-stats/route';

async function fetchBurnStats(): Promise<BurnStatsData> {
  const res = await fetch('/api/rpc/burn-stats');
  if (!res.ok) throw new Error('Failed to fetch burn stats');
  const json = await res.json();
  return json.data as BurnStatsData;
}

/**
 * Polls the cached server-side burn stats endpoint. Both `staleTime`
 * and `refetchInterval` match the 60-second route TTL — the client will
 * pull a fresh snapshot once per minute (cheap thanks to the LRU/Redis
 * cache fronting `/api/rpc/burn-stats`).
 */
export function useBurnStats() {
  return useQuery({
    queryKey: ['burn-stats', 'takeover'],
    queryFn: fetchBurnStats,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: false,
  });
}

export type { BurnStatsData };
